import React, { useCallback, useState, createContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

export const BlogCtx = createContext({
  category: "",
  archive: "",
  dateObj: {
    firstDate: undefined,
    lastDate: undefined,
  },
  categoryChangeHandler: () => {},
  archiveChangeHandler: () => {},
});

const BlogContextProvider = ({ children }) => {
  const history = useHistory();
  const [category, setCategory] = useState("");
  const [archive, setArchive] = useState("");
  const [dateObj, setDateObj] = useState({
    firstDate: undefined,
    lastDate: undefined,
  });
  const categoryChangeHandler = (category) => {
    history.push("/category/blog");
    setCategory(category);
  };
  const archiveChangeHandler = (archive) => {
    history.push("/category/blog");
    setArchive(archive);
  };
  const getFirstAndLastDateFromText = useCallback((inputText) => {
    const [monthName, year] = inputText.split(" ");
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth(); // e.g., April → 3

    const firstDate = new Date(year, monthIndex, 1);
    const lastDate = new Date(year, monthIndex + 1, 0);

    setDateObj({
      firstDate: firstDate.toLocaleDateString("en-CA"),
      lastDate: lastDate.toLocaleDateString("en-CA"),
    });
  }, []);
  useEffect(() => {
    getFirstAndLastDateFromText(archive);
  }, [archive, getFirstAndLastDateFromText]);
  return (
    <BlogCtx.Provider
      value={{
        category,
        archive,
        dateObj,
        categoryChangeHandler,
        archiveChangeHandler,
      }}
    >
      {children}
    </BlogCtx.Provider>
  );
};

export default BlogContextProvider;
